{
  "name": "kvasar-agile-management-front",
  "version": "1.0.0",
  "license": "MIT",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --host 127.0.0.1 --port 4200 --open --proxy-config proxy.conf.json",
    "start:prod": "npm run build:prod && npm run server",
    "build": "ng build",
    "build:prod": "ng build --configuration production",
    "lint": "eslint --color -c .eslintrc --ext .ts .",
    "test": "npm run lint && ng test --configuration=test",
    "watch": "ng test --configuration=test --browsers ChromeHeadless --watch",
    "e2e": "ng e2e",
    "ci": "npm run format:test && ng lint && ng test --configuration=test --browsers ChromeTravisCi --code-coverage && npm run e2e && npm run build:prod -- --deploy-url /angular-ngrx-material-starter/ --base-href /angular-ngrx-material-starter",
    "format:write": "prettier projects/**/*.{ts,json,md,scss} --write",
    "format:test": "prettier projects/**/*.{ts,json,md,scss} --list-different",
    "release": "standard-version && git push --follow-tags origin master",
    "analyze": "npm run build:prod -- --stats-json && webpack-bundle-analyzer ./dist/angular-ngrx-material-starter/stats.json",
    "server": "node ./projects/server/server.js",
    "contributors:add": "all-contributors add",
    "contributors:generate": "all-contributors generate && node .all-contributors-html.js",
    "contributors:check": "all-contributors check",
    "tslint-check": "tslint-config-prettier-check ./tslint.json"
  },
  "husky": {
    "hooks": {
      "pre-commit": "pretty-quick --staged",
      "commit-msg": "commitlint -E HUSKY_GIT_PARAMS"
    }
  },
  "commitlint": {
    "extends": [
      "@commitlint/config-conventional"
    ]
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.0.0",
    "@angular/cdk": "^20.2.14",
    "@angular/common": "^21.0.0",
    "@angular/compiler": "^21.0.0",
    "@angular/core": "^21.0.0",
    "@angular/forms": "^21.0.0",
    "@angular/material": "^20.2.14",
    "@angular/platform-browser": "^21.0.0",
    "@angular/platform-browser-dynamic": "^21.0.0",
    "@angular/router": "^21.0.0",
    "@auth0/auth0-angular": "^2.2.3",
    "@fortawesome/angular-fontawesome": "^2.0.1",
    "@fortawesome/fontawesome-free": "^7.1.0",
    "@fortawesome/fontawesome-svg-core": "^7.1.0",
    "@fortawesome/free-brands-svg-icons": "^7.1.0",
    "@fortawesome/free-regular-svg-icons": "^7.1.0",
    "@fortawesome/free-solid-svg-icons": "^7.1.0",
    "@jmar5439/angular-extensions-model-angular": "17.0.0",
    "@jmar5439/angular-mentions": "16.0.0",
    "@jmar5439/ng-multiselect-dropdown": "^17.0.0",
    "@jmar5439/ngx-color-picker": "^17.0.0",
    "@ng-icons/core": ">=32.0.0 <34.0.0",
    "@ng-icons/lucide": ">=32.0.0 <34.0.0",
    "@ngrx/component-store": "^20.0.0",
    "@ngrx/effects": "^20.0.0",
    "@ngrx/entity": "^20.0.0",
    "@ngrx/operators": "^20.0.0",
    "@ngrx/router-store": "^20.0.0",
    "@ngrx/store": "^20.0.0",
    "@ngrx/store-devtools": "^20.0.0",
    "@ngx-loading-bar/core": "^6.0.2",
    "@ngx-loading-bar/http-client": "^6.0.2",
    "@ngx-loading-bar/router": "^6.0.2",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@spartan-ng/brain": "0.0.1-alpha.570",
    "@spartan-ng/ui-core": "0.0.1-alpha.380",
    "angular-froala-wysiwyg": "^4.7.1",
    "angular-resize-event": "^3.2.0",
    "bootstrap": "^4.5.2",
    "browser-detect": "^0.2.28",
    "chart.js": "^4.5.1",
    "chartjs-adapter-luxon": "^1.3.1",
    "chartjs-chart-financial": "^0.1.1",
    "chartjs-plugin-annotation": "^1.0.2",
    "chartjs-plugin-datalabels": "^2.0.0",
    "class-variance-authority": "^0.7.0",
    "clsx": "^2.1.1",
    "dexie": "^3.2.2",
    "froala-editor": "^4.7.1",
    "jackson-js": "^1.1.0",
    "jsonpath": "^1.0.2",
    "jwt-decode": "^4.0.0",
    "luxon": "^3.5.0",
    "ng2-charts": "^5.0.4",
    "ngx-quill": "^18.0.0",
    "ngx-sonner": ">=3.0.0",
    "quill": "^2.0.3",
    "rxjs": "^7.8.2",
    "tailwind-merge": "^3.3.1",
    "tslib": "^2.0.0",
    "uuid": "^8.3.0",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.0.0",
    "@angular-eslint/builder": "^20.6.0",
    "@angular-eslint/eslint-plugin": "^20.6.0",
    "@angular-eslint/eslint-plugin-template": "^20.6.0",
    "@angular-eslint/schematics": "^20.6.0",
    "@angular-eslint/template-parser": "^20.6.0",
    "@angular/cli": "^21.0.0",
    "@angular/compiler-cli": "^21.0.0",
    "@angular/language-service": "^21.0.0",
    "@angular/localize": "^21.0.0",
    "@commitlint/cli": "^11.0.0",
    "@commitlint/config-conventional": "^11.0.0",
    "@ngrx/eslint-plugin": "^20.0.0",
    "@ngrx/schematics": "^20.0.0",
    "@spartan-ng/cli": "^0.0.1-alpha.570",
    "@tailwindcss/postcss": "^4.1.17",
    "@types/jasmine": "~3.6.0",
    "@types/node": "^20.19.25",
    "@types/quill": "^2.0.14",
    "@types/uuid": "^8.3.0",
    "@typescript-eslint/eslint-plugin": "5.3.0",
    "@typescript-eslint/parser": "5.3.0",
    "all-contributors-cli": "^6.17.4",
    "autoprefixer": "^10.4.22",
    "codelyzer": "^6.0.0",
    "eslint": "^8.2.0",
    "eslint-config-prettier": "^6.15.0",
    "eslint-plugin-import": "2.25.2",
    "express": "^4.16.4",
    "husky": "^4.3.0",
    "jasmine-core": "~3.6.0",
    "jasmine-spec-reporter": "~5.0.0",
    "karma": "~6.4.2",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage-istanbul-reporter": "~3.0.2",
    "karma-jasmine": "~4.0.0",
    "karma-jasmine-html-reporter": "^1.5.0",
    "karma-spec-reporter": "^0.0.32",
    "npm-run-all": "^4.1.5",
    "postcss": "^8.5.6",
    "prettier": "^2.2.1",
    "pretty-quick": "^3.1.0",
    "protractor": "~7.0.0",
    "raw-loader": "^4.0.2",
    "rimraf": "^3.0.2",
    "standard-version": "~9.0.0",
    "tailwindcss": "^4.1.17",
    "ts-node": "~9.0.0",
    "tw-animate-css": "^1.4.0",
    "typescript": "5.9.3",
    "webpack-bundle-analyzer": "^4.1.0"
  },
  "type": "module"
}
